import React from "react";
import "./monthlybulletin.css";
//import imgfr from "../../assets/pics/frandre.png";
import { useTransition, useTranslation } from "react-i18next";
//import En_Jan25 from "../../assets/pdffiles/report/En_Jan_25_Monthly_Bulletin.pdf";
//import Fr_Jan25 from "../../assets/pdffiles/report/Fr_Jan_25_Monthly_Bulletin.pdf";
import { Container } from "react-bootstrap";

function monthlyNews() {
  const { t, i18n } = useTranslation();

  const News_Bulletin = t('Downloads_News_Bulletin', {
    returnObjects: true
  });
  return (
    <div>
      <h4 className="headingText">{t("News")}</h4>

     <Container>
      <ol className="Higher_Monthlynewsbulletin"  >
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_Jan_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_Jan_25.title')}</a>
      </li>
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_Feb_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_Feb_25.title')}</a>
      </li>
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_March_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_March_25.title')}</a>
      </li>
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_April_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_April_25.title')}</a>
      </li>
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_May_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_May_25.title')}</a>
      </li>
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_June_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_June_25.title')}</a>
      </li>
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_July_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_July_25.title')}</a>
      </li>
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_Aug_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_Aug_25.title')}</a>
      </li>
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_Sept_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_Sept_25.title')}</a>
      </li>
      <li className="Monthly_News_Bulletin">
        <a href={t('Downloads_Report_Oct_25.download')} target="_blank" rel="noopener noreferrer"
        > {t('Downloads_Report_Oct_25.title')}</a>
      </li>
      </ol>
      </Container>
    </div>

  );
  
}
export default monthlyNews;